$(document).ready(function(){
//     function waitForElement() {
//     let interval = setInterval(function () {
//         let $el = $("span.appstle_subscription_amount.transcy-money");
//         if ($el.length > 0) {
//             $el.after('<span>Element found</span>');
//             clearInterval(interval); // stop interval once found
//         }
//     }, 100);
// }

// waitForElement();
    function priceUpdate(multiplier){
        var totalPrice = $('.prd_page_price span.price-item.price-item--regular').text().replace('$','').replace('USD','');
        //alert(totalPrice);
        $('span.appstle_subscription_amount.transcy-money').each(function(){
            var numericPrice = parseFloat(totalPrice); 

            if (!isNaN(numericPrice)) {
                 var updatedPrice = (numericPrice * multiplier).toFixed(2);
                 if ($(this).next('.update_price').length > 0) {
                 $(this).next('.update_price').text(`$ ${updatedPrice}`);
                } else {
                    $(this).after(`<span class="update_price">$ ${updatedPrice}</span>`);
                }
            }
        });
        
    //alert(totalPrice);
    }
    
    
    
    $(document).on('click', '.appstle_subscription_radio_wrapper, .appstle_one_time_details_wrapper', function(){
         setTimeout(function(){
            var getVariantTitleOnsell = $('.prd_varint_title').text();
            console.log(getVariantTitleOnsell);
          //alert(getVariantTitleOnsell);
            if(getVariantTitleOnsell == '6 PACK (+2 FREE)') {
            setTimeout(function(){
                    priceUpdate(6);
                }, 1500);
            }else if (getVariantTitleOnsell == '3 PACK'){
                setTimeout(function(){
                    priceUpdate(3);
                }, 1500);
            }else {
                setTimeout(function(){
                    priceUpdate(1);
                }, 1500);
            }
        },500)
    });

    

    var getVariantTitle = $('.prd_varint_title').text();
    //alert(getVariantTitle);
    if(getVariantTitle == '6 PACK (+2 FREE)') {
        $('.bundle_product_box').show();
        $('.custom_add_to_cart .button').attr('bundle', 'true');
        $('#custom_quantity_prd').val(6);
        setTimeout(function(){
            priceUpdate(6);
        }, 1500);
    }else if (getVariantTitle == '3 PACK'){
        $('#custom_quantity_prd').val(3);
        setTimeout(function(){
            priceUpdate(3);
        }, 1500);
    }else {
        $('#custom_quantity_prd').val(1); 
        setTimeout(function(){
            priceUpdate(1);
        }, 1500);
    }

    $(document).on("change", "select.appstle_select", function() {
        
        setTimeout(function(){
             var getVariantTitleOnsell = $('.prd_varint_title').text();
            console.log(getVariantTitleOnsell);
          //alert(getVariantTitleOnsell);
            if(getVariantTitleOnsell == '6 PACK (+2 FREE)') {
            setTimeout(function(){
                    priceUpdate(6);
                }, 1500);
            }else if (getVariantTitleOnsell == '3 PACK'){
                setTimeout(function(){
                    priceUpdate(3);
                }, 1500);
            }else {
                setTimeout(function(){
                    priceUpdate(1);
                }, 1500);
            }
        },500)
        
        //alert("changed");
       
    });
    var  changeVariantTitle;
    $(document).on('click', '.product .product-form__input--pill label', function(){
        changeVariantTitle = $(this).prev().val();
        // alert(changeVariantTitle);
        if(changeVariantTitle == '6 PACK (+2 FREE)') {
            $('.bundle_product_box').slideDown();
            $('.custom_add_to_cart .button').attr('bundle', 'true');
            $('#custom_quantity_prd').val(6);
            setTimeout(function(){
                priceUpdate(6);
            }, 1500);
        }else if (changeVariantTitle == '3 PACK'){
            $('.bundle_product_box').slideUp();
            $('.custom_add_to_cart .button').attr('bundle', 'false');
            $('#custom_quantity_prd').val(3);
            setTimeout(function(){
                priceUpdate(3);
            }, 1500);
        }
        else {
            $('.bundle_product_box').slideUp();
            $('.custom_add_to_cart .button').attr('bundle', 'false');
            $('#custom_quantity_prd').val(1); 
            setTimeout(function(){
                priceUpdate(1);
            }, 1500);
        }
    });
    $(document).on('click', '.custom_add_to_cart .button[bundle="false"]', function(){
        $('.product-form__submit').trigger('click');
        $('.custom_add_to_cart .button[bundle="false"] .loading__spinner').removeClass('hidden');
    });
    
    $(document).on('change', '.product_element', function() {
        var $select = $(this);

        if ($select.find('option:first').is(':selected')) {
            $select.addClass("not_selected");
        } else {
            $select.removeClass("not_selected");
        }
    });

    $(document).on('click', '.custom_add_to_cart .button[bundle="true"]', function() {
        
    var items = [];
                var productCount = 1;
                var $form = $(".bundle_property_main_prd");
                //alert($form);
                
                $form.find(".bundle-property").remove();
                var selectedValues = [];
                var url = window.location.href;
                var urlParams = new URLSearchParams(window.location.search);
                var sellingPlanId = urlParams.get("selling_plan");
                var mainPrdSellPlan; 
                var mainPrdTitle = $('.product__title h1').text();
                var getVariantTitlecart = $('.product .product-form__input--pill input[type=radio]:checked').val();
                mainPrdTitle = mainPrdTitle +" "+  getVariantTitlecart ;
                //alert(getVariantTitlecart);

                if (sellingPlanId) {
                    //alert("Selling Plan ID: " + sellingPlanId);
                    mainPrdSellPlan = $(".appstle_select option:selected").text();
                    mainPrdSellPlan = mainPrdSellPlan.toLowerCase().replace(/\s+/g, "-");
                    //alert(mainPrdSellPlan);
                }
            $('.product_element').each(function() {
                var $select = $(this);
                var selectedOption = $select.find('option:selected'); 
                var productAvalId = selectedOption.attr("product_aval_id"); 
                var value = selectedOption.val();
                if (sellingPlanId) {
                   var sellingPlan = selectedOption.attr(mainPrdSellPlan);
                }
                if (!$select.find('option:first').is(':selected')) {
                    $select.removeClass("not_selected");

                    // Push variant + selling plan into items array
                    var item = {
                        id: productAvalId,
                        quantity: 1,
                        properties: {
                            "Included In": mainPrdTitle
                        }
                    };
                    if (sellingPlanId) {
                        if (sellingPlan) {
                            item.selling_plan = sellingPlan;
                        }
                    }

                    items.push(item);
                } else {
                    $select.addClass("not_selected");
                }

                if (value && value !== "") {
                    selectedValues.push(value);
                }
            });

            var bundleNotSelectLength = $('.product_element.not_selected').length;
            if(bundleNotSelectLength == 0){
                $.each(selectedValues, function (i, val) {
                        //alert(val);
                        var input = $('<input>', {
                            type: 'hidden',
                            class: 'bundle-property',
                            name: 'properties[Product ' + (i + 1) + ']',
                            value: val
                        });

                        $form.append(input);
                    });
                $('.custom_add_to_cart .button[bundle="true"] .loading__spinner').removeClass('hidden');
                if (items.length > 0) {
                    
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: JSON.stringify({ items: items }),
                        dataType: 'json',
                        contentType: 'application/json',
                        success: function(cart) {
                            $('.product-form__submit').trigger('click');
                            console.log("Added to cart:", cart);
                            // optionally redirect to cart
                            // window.location.href = '/cart';
                        },
                        error: function(err) {
                            console.error("Error adding to cart:", err);
                        }
                    });
                } else {
                    alert("Please select at least one product option.");
                }
            }
});

//** DISABLE CUSTOM ADD TO CART BUTTON START **//
function disabledCustomAddBtn(){
        var disableBtn = $('.btn_wrapper .product-form__submit[disabled]');
        if(disableBtn.length>0){
            $('.custom_add_to_cart .text').text('Sold out');
            $('.custom_add_to_cart .button').attr('disabled', 'disabled');
        }else {
            $('.custom_add_to_cart .text').text('Add to cart');
            $('.custom_add_to_cart .button').removeAttr('disabled');
        }
}

setInterval(function(){
  disabledCustomAddBtn();
},500);
// disabledCustomAddBtn();
// $(document).on('click', '.product__info-wrapper variant-selects', function(){
//     disabledCustomAddBtn();
// })
//** DISABLE CUSTOM ADD TO CART BUTTON END **//



});